import React from "react";
import "../App.css";

/**
 * Card reutilizável para exibir um "pilar" de atuação (ícone + título + texto).
 * Usado na Home (seção "Nossos Pilares de Atuação") e em outras páginas.
 *
 * Props:
 * - icon: ReactNode (svg/ícone)
 * - title: string
 * - text: string
 * - index: number (opcional) — usado apenas para variar sutilmente a
 *   posição/animação de cada card via CSS (efeito mais orgânico, sem
 *   depender de nth-child em grids diferentes)
 */
export default function PillarCard({ icon, title, text, index = 0 }) {
  return (
    <div className="pillar-card" style={{ "--card-index": index }}>
      <div className="pillar-card__glow" aria-hidden="true" />
      <div className="pillar-card__icon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="pillar-card__title">{title}</h3>
      <p className="pillar-card__text">{text}</p>
    </div>
  );
}
